import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify"; // Import toast and ToastContainer
import "react-toastify/dist/ReactToastify.css"; // Import Toastify styles
import axios from "axios"; // Import axios

const FeesPaymentClassList = () => {
  const { class_number } = useParams();
  const [students, setStudents] = useState([]);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/students/fetch/${class_number}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data && Array.isArray(response.data)) {
          const sortedStudents = response.data.sort((a, b) =>
            a.student_name.localeCompare(b.student_name)
          );
          setStudents(sortedStudents);
          if (response.data.length === 0) {
            toast.info("No students found for this class.");
          }
        }
      } catch (error) {
        toast.error("Error fetching student data");
      } finally {
        // Set loading to false after request completes
      }
    };

    if (class_number) {
      fetchStudents();
    }
  }, [class_number]);

  return (
    <>
      <div className="container mt-5 bg-white rounded p-5 mb-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <Link to="/erp/fees" className="btn btn-secondary mb-3">
              &#8592; Select Class
            </Link>
            <h3 className="text-center text-success">
              Student List from Class {class_number}
            </h3>
          </div>
          <div className="table-responsive mt-4">
            {students.length === 0 ? (
              <p>No students found for this class.</p>
            ) : (
              <table className="table table-striped table-hover table-bordered text-center">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Student Name</th>
                    <th>Student ID</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student, index) => (
                    <tr key={student.student_id}>
                      <td>{index + 1}</td>
                      <td>{student.student_name}</td>
                      <td>{student.student_id}</td>
                      <td style={{ width: "25rem" }}>
                        <Link
                          to={`/erp/fees/payment/details/${student.student_id}`}
                        >
                          <button className="btn btn-success btn-sm mx-3">
                            Pay Fees & Check History
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      <ToastContainer /> {/* To render the toast notifications */}
    </>
  );
};

export default FeesPaymentClassList;
